import { Maximize2 } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { COLLATERAL } from "@/data/site";

export const Collateral = ({ onPoster }) => (
  <section id="collateral" className="relative py-32 sm:py-40" data-testid="collateral-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        eyebrow="08 — Brand Collateral"
        title="The KMG Digi campaign posters."
        sub="Every official KMG Digi Platform poster, viewable in full detail."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-20">
        {COLLATERAL.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.07}>
            <button
              onClick={() => onPoster(c.src)}
              data-testid={`collateral-card-${c.id}`}
              className="lift group block w-full text-left border border-[rgba(111,227,155,0.16)] bg-[color:var(--kmg-emerald)] hover:border-[color:var(--kmg-lime)]"
            >
              <div className="h-72 overflow-hidden">
                <img src={c.src} alt={c.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="p-6 flex items-center justify-between gap-4">
                <h3 className="font-display text-base leading-snug">{c.title}</h3>
                <Maximize2 size={15} className="text-[color:var(--kmg-lime)] shrink-0" />
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
